import styled from 'styled-components';

const Plate = styled.div`
  background-color: var(--color-bg-tertiary);
  border: 1px solid var(--color-border-primary);
  border-radius: 4px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`;
const LeftPlate = styled.div`
  border-right: 1px solid var(--color-border-primary);
  padding: 4px 12px;
`;
const MiddlePlate = styled.div`
  border-right: 1px solid var(--color-border-primary);
  padding: 4px 12px;
`;
const RightPlate = styled.div`
  padding: 4px 12px;
`;

const PlateStyles = {
  Plate,
  LeftPlate,
  MiddlePlate,
  RightPlate,
};

export default PlateStyles;
